import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import OwnerLogin from "@/components/OwnerLogin";
import OwnerDashboard from "@/components/OwnerDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Owner() {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then(({ data }) => setUser(data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-espresso-deep" data-testid="owner-checking">
        <Loader2 className="h-8 w-8 animate-spin text-gold" />
      </div>
    );
  }

  return user ? (
    <OwnerDashboard user={user} onLogout={() => setUser(null)} />
  ) : (
    <OwnerLogin onLogin={setUser} />
  );
}